<template>
    <div class="stores">
        <b-tabs class="container">
            <b-tab :title="langStoresPage.alphabet[locale]" class="text-left" active>
                <div class="text-center" v-if="loadingStores">
                    <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
                </div>
                <div class="stores-wrapper" v-for="(store, i) in storesByAlphabet" :key="i" v-else-if="storesByAlphabet.length > 0">
                    <h4 class="stores-wrapper-header text-info text-left">
                        {{store.group}}
                    </h4>
                    <div class="stores-items" v-for="(item, n) in store.children" :key="n">
                        <router-link class="store-link" :to="'/user/'+item._id">
                            {{item.name}} <small class="store-city">{{item.city}}</small><small class="store-badge"><b-badge>{{item.totalItemsForSale}}</b-badge></small>
                        </router-link>
                        <br />
                    </div>
                </div>
                <div class="stores-wrapper" v-else-if="statusOk">
                    <h4>{{langStoresPage.noStoresFound[locale]}}</h4>
                </div>
                <div class="stores-wrapper" v-else>
                    <b-alert show variant="danger">{{errMessage ? errMessage : 'Error! Server error.'}}</b-alert>
                </div>
            </b-tab>
            <b-tab :title="langStoresPage.city[locale]" class="text-left">
                <div class="text-center" v-if="loadingStores">
                    <font-awesome-icon class="spinner" size="2x" icon="circle-notch" :spin="true"/>
                </div>
                <div class="stores-wrapper" v-for="(store, i) in storesByCity" :key="i" v-else-if="storesByCity.length > 0">
                    <h4 class="stores-wrapper-header text-info text-left">
                        {{store.group}}
                    </h4>
                    <div class="stores-items" v-for="(item, n) in store.children" :key="n">
                        <router-link class="store-link" :to="'/user/'+item._id">
                            {{item.name}} <small class="store-city">{{item.city}}</small><small class="store-badge"><b-badge>{{item.totalItemsForSale}}</b-badge></small>
                        </router-link>
                        <br />
                    </div>
                </div>
                <div class="stores-wrapper" v-else-if="statusOk">
                    <h4>{{langStoresPage.noStoresFound[locale]}}</h4>
                </div>
                <div class="stores-wrapper" v-else>
                    <b-alert show variant="danger">{{errMessage ? errMessage : 'Error! Server error.'}}</b-alert>
                </div>
            </b-tab>
        </b-tabs>
    </div>
</template>

<script>
import { mapState } from 'vuex';
import langStoresPage from '@/store/lang/storesPage';

export default {
    name: "stores",
    computed: mapState({
        loadingStores: state => state.Stores.loadingStores,
        statusOk: state => state.Stores.statusOk,
        errMessage: state => state.Stores.errMessage,
        okMessage: state => state.Stores.okMessage,
        storesByAlphabet: state => state.Stores.storesByAlphabet,
        storesByCity: state => state.Stores.storesByCity,
        locale: state => state.locale
    }),
    mounted() {
        this.$store.dispatch('STORES_FETCH');
    },
    data() {
        return {
            langStoresPage
        }
    }
}
</script>

<style scope lang="scss">
.stores {
    margin: 1em;
    .spinner {
        margin: 2em;
    }

    .stores-wrapper {
        display: inline-block;
        vertical-align: top;
        padding: 1em;
        margin: 1em;

        .stores-items {
            .store-link {
                font-weight: bold;
                color: rgba(0,0,0,0.8);
                .store-badge {
                    vertical-align: text-top;
                    padding: 0.25em;
                }
            }
        }
    }
}
</style>
